import {
  RECOMMENDS_VALIDATE,
  RECOMMENDS,
  RECOMMENDS_CREATE,
  RECOMMENDS_WATCH,
  RECOMMENDS_HISTORY,
  RECOMMENDS_DELETE
} from 'client/api';
import { clientAdmin } from 'client/request';
import queryString from 'query-string';

const validateWatchlist = async (ticker) => {
  const paramString = queryString.stringify({ ticker });
  const url = paramString ? `${RECOMMENDS_VALIDATE}?${paramString}` : RECOMMENDS_VALIDATE;

  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.get(url, {});
    return res.data?.data || [];
  } catch (err) {
    throw err;
  }
};

const getRecommendHistory = async (transactionId) => {
  const paramString = queryString.stringify({ transactionId });
  const url = paramString ? `${RECOMMENDS_HISTORY}?${paramString}` : RECOMMENDS_HISTORY;

  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.get(url, {});
    return res.data?.data || [];
  } catch (err) {
    throw err;
  }
};

const getRecommends = async (portfolioId) => {
  const paramString = queryString.stringify({ portfolioId });
  const url = paramString ? `${RECOMMENDS}?${paramString}` : RECOMMENDS;

  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.get(url, {});
    return res.data?.data || [];
  } catch (err) {
    throw err;
  }
};

const getWatchlist = async () => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.get(RECOMMENDS_WATCH, {});
    return res.data?.data || [];
  } catch (err) {
    throw err;
  }
};

const recommendWatchlist = async (body) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.post(RECOMMENDS_WATCH, body);
    return res.data;
  } catch (err) {
    throw err;
  }
};

const createRecommend = async (body) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.post(RECOMMENDS_CREATE, body);
    return res.data;
  } catch (err) {
    throw err;
  }
};

const updateRecommend = async (body) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.post(RECOMMENDS, body);
    return res.data;
  } catch (err) {
    throw err;
  }
};

const deleteRecommend = async (body) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.delete(RECOMMENDS_DELETE, { data: body });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export default {
  validateWatchlist,
  recommendWatchlist,
  getWatchlist,
  getRecommends,
  createRecommend,
  updateRecommend,
  deleteRecommend,
  getRecommendHistory
};
